// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
export type ScopeHistoryDetailsFragment = { __typename?: 'ProjectItemScopeChange', costInCents: number, priceInCents: number, quantity?: number | null | undefined, tradePartnerNote?: string | null | undefined, specifications?: string | null | undefined, shortName: string };

export type ProjectItemUnitOfMeasureFragment = { __typename?: 'UnitOfMeasure', id: string, name: string, useQuantity: boolean };

export const ScopeHistoryDetailsFragmentDoc = gql`
    fragment ScopeHistoryDetails on ProjectItemScopeChange {
  costInCents
  priceInCents
  quantity
  tradePartnerNote
  specifications
  shortName
}
    `;
export const ProjectItemUnitOfMeasureFragmentDoc = gql`
    fragment ProjectItemUnitOfMeasure on UnitOfMeasure {
  id
  name
  useQuantity
}
    `;